import cn from 'classnames';
import styles from './EventStatus.module.scss';

export default function EventStatus({ status }) {
  return (
    <div className={cn(styles.eventStatus, styles[status.toLowerCase()])}>
      {status}
    </div>
  )
}
